import AGREGAR_DEDUCCION from '@/graphql/mutations/administracion/catalogos/deducciones/agregarDeducciones.gql';
import DEDUCCIONES from '@/graphql/querys/administracion/catalogos/deducciones/deducciones.gql';
import ACTUALIZAR_DEDUCCION from '@/graphql/mutations/administracion/catalogos/deducciones/actualizarDeduccion.gql';
import REMOVER_DEDUCCION from '@/graphql/mutations/administracion/catalogos/deducciones/removerDeduccion.gql';

export default {
  methods: {
    async mixAgregarDeduccion() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_DEDUCCION,
          variables: this.deduccion,
          update: (store, { data: { agregarDeduccion } }) => {
            const data = store.readQuery({ query: DEDUCCIONES });
            data.deducciones.push(agregarDeduccion);
            store.writeQuery({ query: DEDUCCIONES, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarDeduccion() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_DEDUCCION,
        variables: {
          id: this.deduccionEditar.id,
          nombre: this.deduccion.nombre,
          porcentaje: this.deduccion.porcentaje,
        },
        update: (store, { data: { actualizarDeduccion } }) => {
          const data = store.readQuery({ query: DEDUCCIONES });
          const { deducciones } = data;
          const index = deducciones
            .findIndex((deduccion) => deduccion.id
            === actualizarDeduccion.id);
          if (index !== -1) {
            deducciones.splice(index, 1, actualizarDeduccion);
          }
          store.writeQuery({ query: DEDUCCIONES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarDeduccion() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_DEDUCCION,
        variables: {
          id: this.deduccionEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: DEDUCCIONES });
          const { deducciones } = data;
          const index = deducciones
            .findIndex((deduccion) => deduccion.id
            === this.deduccionEliminar.id);
          if (index !== -1) {
            deducciones.splice(index, 1);
          }
          store.writeQuery({ query: DEDUCCIONES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
